import type { Contacts, WordingsParams, WordingsResponse } from './types';
import { BaseService, defineApi } from '@/shared/api';

class CommonInfoService extends BaseService {
  /** https://qicbizdev.atlassian.net/wiki/spaces/QB/pages/1142816803 */
  async fetchWordings(params: WordingsParams): Promise<WordingsResponse[]> {
    return await this.get('/getqatarwordings', { params });
  }

  // https://qicbizdev.atlassian.net/wiki/spaces/QB/pages/460686118
  async fetchContacts(region: string = 'qatar'): Promise<Contacts[]> {
    return await this.get(`/getcontacts?region=${region}`, {
      baseURL: import.meta.env.VUE_APP_API_LEGACY_URL ?? '/',
    });
  }
}

export const useCommonInfoService = defineApi(CommonInfoService);
